import React from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid } from '@material-ui/core';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import GroupIcon from '@material-ui/icons/Group';
// import "../BreakDown/Breakdown.css";
import "../Preventive Maintenance/PreventiveMaintenance.css";
import { useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../Breadcrumb';

const UserManagement = () => {
    const navigate = useNavigate();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Settings', href: '/settings' }
    ];

    const handler = (route) => {
        navigate(route)
    }
    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h3" component="h1" gutterBottom>
                        User Management
                    </Typography>
                </Box> */}
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="User Management" />
                </Box>
                <Box mb={2}>
                    <Grid container spacing={2}>
                        <Grid item className='PM' xs={12} sm={5} onClick={() => handler("/user-management/add-user")}>
                            <div className='options'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <PersonAddIcon className='MuiIcon-fontSizeLarge' />
                                    <p className='text'>
                                        Add User
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>

                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item className='PM' xs={12} sm={5} onClick={() => handler("/user-management/view-User-list")}>
                            <div className='options'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <GroupIcon className='MuiIcon-fontSizeLarge' />
                                    <p className='text'>
                                        View Users
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                    </Grid>
                    {/* <Grid container spacing={4}>
                        <Grid item className='PM' xs={12} sm={5} onClick={() => handler("/pm/log-overview")}>
                            <div className='options'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <PersonAddIcon className='MuiIcon-fontSizeLarge' />
                                    <p className='text'>
                                        Add Department
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                        <Grid item className='PM' xs={12} sm={5} onClick={() => handler("/pm/log-overview")}>
                            <div className='options'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <GroupIcon className='MuiIcon-fontSizeLarge' />
                                    <p className='text'>
                                        View Departments
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                    </Grid> */}
                </Box>
            </Container>
        </Layout>
    );
};

export default UserManagement;
